<div class="centerInGrid">
    <app-button *ngIf="!disabled"
        [label]="label" 
        [severity]="'warning'"
        [outlined]="false" 
        (onClickEvent)="onClick()">
    </app-button>
</div>